
import Config from "../config";
import {FileModel} from '../models/models';
import {CartAModel,
        CartAFactory} from '../models/modelsCart';


export const retrieveCart = async (authToken: string,
                                   cartType: string): Promise<{'cart': CartAModel}> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/cart/r/${cartType}`;

      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }
      if(!data.cart){
          throw new Error("Unhandled error")
      }

      const thisPromise = {'cart': new CartAFactory().fromJSON(data.cart)}

      return thisPromise

    } catch (error){
      throw new Error(`Error when fetching cart: ${(error as Error).message}`)
    }
}


export const refreshCart = async (authToken: string,
                                  cartType: string,
                                  selectedProductUuids: string[]): Promise<{'cart': CartAModel}> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/cart/refresh/${cartType}`;

      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const body = {'selected_product_uuids': selectedProductUuids}


      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }
      if(!data.cart){
          throw new Error("Unhandled error")
      }

      const thisPromise = {'cart': new CartAFactory().fromJSON(data.cart)}

      return thisPromise

    } catch (error){
      throw new Error(`Error when refreshing cart: ${(error as Error).message}`)
    }
}


export const submitCart = async (authToken: string,
                                  cartType: string,
                                  selectedProductUuids: string[],
                                  orderDate: Date,
                                  context: any): Promise<any> => {
    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/cart/submit/${cartType}`;

      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const body = {'selected_product_uuids': selectedProductUuids,
                    'order_date': orderDate,
                    'context': context}

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();
      if(!data){
          throw new Error("Unhandled error")
      }

      return data

    } catch (error){
      throw new Error(`Error when submitting cart: ${(error as Error).message}`)
    }
}
